<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      :text-color="textColor"
      :active-text-color="textColorActive"
    >
      <!-- <span style="font-size: 8px; line-height: 4px;">{{JSON.stringify(permission_routers)}}</span> -->
      <sidebar-item :routes="permission_routers"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import powered from "@/assets/group-5.png";
import { colors } from "@/styles/variables.js";

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(["permission_routers", "sidebar"]),
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  data() {
    return {
      powered,
      textColor: colors.sidebarMenuItemTextColor,
      textColorActive: colors.sidebarMenuItemTextColorActive,
      permission_routers: [
        {
          path: "/NanoVerify",
          component: {
            name: "layout",
            components: {
              Navbar: {
                mixins: [{ methods: {} }],
                components: {
                  Breadcrumb: {
                    computed: {},
                    watch: {},
                    methods: {},
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-b50ef614",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file: "src/components/Breadcrumb/index.vue"
                  },
                  Hamburger: {
                    name: "Hamburger",
                    props: { isActive: { default: true } },
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-4e6f274c",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file: "src/components/Hamburger/index.vue"
                  }
                },
                computed: {},
                methods: {},
                staticRenderFns: [],
                _compiled: true,
                _scopeId: "data-v-797e31be",
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/Navbar.vue",
                _Ctor: {}
              },
              Sidebar: {
                components: {
                  SidebarItem: {
                    name: "SidebarItem",
                    props: { routes: {}, isNest: { default: false } },
                    methods: {},
                    computed: {},
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-3ece4f7e",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file:
                      "src/views/layout/components/Sidebar/SidebarItem.vue"
                  }
                },
                computed: {},
                methods: {},
                staticRenderFns: [],
                _compiled: true,
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/Sidebar/index.vue",
                _Ctor: {}
              },
              AppMain: {
                name: "AppMain",
                computed: {},
                staticRenderFns: [],
                _compiled: true,
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/AppMain.vue",
                _Ctor: {}
              }
            },
            mixins: [{ watch: {}, methods: {} }],
            computed: {},
            methods: {},
            staticRenderFns: [],
            _compiled: true,
            _scopeId: "data-v-60f35ab6",
            beforeCreate: [null],
            beforeDestroy: [null],
            __file: "src/views/layout/Layout.vue",
            _Ctor: {}
          },
          children: [
            {
              path: "",
              name: "Public-NanoVerify",
              meta: {
                title: "NanoVerify",
                icon: "dashboard",
                class: "material-icons",
                size: "16px",
                special: false
              }
            }
          ]
        },
        {
          path: "/GrapheneVerify",
          component: {
            name: "layout",
            components: {
              Navbar: {
                mixins: [{ methods: {} }],
                components: {
                  Breadcrumb: {
                    computed: {},
                    watch: {},
                    methods: {},
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-b50ef614",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file: "src/components/Breadcrumb/index.vue"
                  },
                  Hamburger: {
                    name: "Hamburger",
                    props: { isActive: { default: true } },
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-4e6f274c",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file: "src/components/Hamburger/index.vue"
                  }
                },
                computed: {},
                methods: {},
                staticRenderFns: [],
                _compiled: true,
                _scopeId: "data-v-797e31be",
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/Navbar.vue",
                _Ctor: {}
              },
              Sidebar: {
                components: {
                  SidebarItem: {
                    name: "SidebarItem",
                    props: { routes: {}, isNest: { default: false } },
                    methods: {},
                    computed: {},
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-3ece4f7e",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file:
                      "src/views/layout/components/Sidebar/SidebarItem.vue"
                  }
                },
                computed: {},
                methods: {},
                staticRenderFns: [],
                _compiled: true,
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/Sidebar/index.vue",
                _Ctor: {}
              },
              AppMain: {
                name: "AppMain",
                computed: {},
                staticRenderFns: [],
                _compiled: true,
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/AppMain.vue",
                _Ctor: {}
              }
            },
            mixins: [{ watch: {}, methods: {} }],
            computed: {},
            methods: {},
            staticRenderFns: [],
            _compiled: true,
            _scopeId: "data-v-60f35ab6",
            beforeCreate: [null],
            beforeDestroy: [null],
            __file: "src/views/layout/Layout.vue",
            _Ctor: {}
          },
          children: [
            {
              path: "",
              name: "Public-GrapheneVerify",
              meta: {
                title: "GrapheneVerify",
                icon: "dashboard",
                class: "material-icons",
                size: "16px",
                special: false
              }
            }
          ]
        },
        {
          path: "/NanoTrust",
          component: {
            name: "layout",
            components: {
              Navbar: {
                mixins: [{ methods: {} }],
                components: {
                  Breadcrumb: {
                    computed: {},
                    watch: {},
                    methods: {},
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-b50ef614",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file: "src/components/Breadcrumb/index.vue"
                  },
                  Hamburger: {
                    name: "Hamburger",
                    props: { isActive: { default: true } },
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-4e6f274c",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file: "src/components/Hamburger/index.vue"
                  }
                },
                computed: {},
                methods: {},
                staticRenderFns: [],
                _compiled: true,
                _scopeId: "data-v-797e31be",
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/Navbar.vue",
                _Ctor: {}
              },
              Sidebar: {
                components: {
                  SidebarItem: {
                    name: "SidebarItem",
                    props: { routes: {}, isNest: { default: false } },
                    methods: {},
                    computed: {},
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-3ece4f7e",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file:
                      "src/views/layout/components/Sidebar/SidebarItem.vue"
                  }
                },
                computed: {},
                methods: {},
                staticRenderFns: [],
                _compiled: true,
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/Sidebar/index.vue",
                _Ctor: {}
              },
              AppMain: {
                name: "AppMain",
                computed: {},
                staticRenderFns: [],
                _compiled: true,
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/AppMain.vue",
                _Ctor: {}
              }
            },
            mixins: [{ watch: {}, methods: {} }],
            computed: {},
            methods: {},
            staticRenderFns: [],
            _compiled: true,
            _scopeId: "data-v-60f35ab6",
            beforeCreate: [null],
            beforeDestroy: [null],
            __file: "src/views/layout/Layout.vue",
            _Ctor: {}
          },
          children: [
            {
              path: "",
              name: "Public-NanoTrust",
              meta: {
                title: "NanoTrust",
                icon: "dashboard",
                class: "material-icons",
                size: "16px",
                special: false
              }
            }
          ]
        },
        {
          path: "/NT-NanoMark",
          component: {
            name: "layout",
            components: {
              Navbar: {
                mixins: [{ methods: {} }],
                components: {
                  Breadcrumb: {
                    computed: {},
                    watch: {},
                    methods: {},
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-b50ef614",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file: "src/components/Breadcrumb/index.vue"
                  },
                  Hamburger: {
                    name: "Hamburger",
                    props: { isActive: { default: true } },
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-4e6f274c",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file: "src/components/Hamburger/index.vue"
                  }
                },
                computed: {},
                methods: {},
                staticRenderFns: [],
                _compiled: true,
                _scopeId: "data-v-797e31be",
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/Navbar.vue",
                _Ctor: {}
              },
              Sidebar: {
                components: {
                  SidebarItem: {
                    name: "SidebarItem",
                    props: { routes: {}, isNest: { default: false } },
                    methods: {},
                    computed: {},
                    staticRenderFns: [],
                    _compiled: true,
                    _scopeId: "data-v-3ece4f7e",
                    beforeCreate: [null],
                    beforeDestroy: [null],
                    __file:
                      "src/views/layout/components/Sidebar/SidebarItem.vue"
                  }
                },
                computed: {},
                methods: {},
                staticRenderFns: [],
                _compiled: true,
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/Sidebar/index.vue",
                _Ctor: {}
              },
              AppMain: {
                name: "AppMain",
                computed: {},
                staticRenderFns: [],
                _compiled: true,
                beforeCreate: [null],
                beforeDestroy: [null],
                __file: "src/views/layout/components/AppMain.vue",
                _Ctor: {}
              }
            },
            mixins: [{ watch: {}, methods: {} }],
            computed: {},
            methods: {},
            staticRenderFns: [],
            _compiled: true,
            _scopeId: "data-v-60f35ab6",
            beforeCreate: [null],
            beforeDestroy: [null],
            __file: "src/views/layout/Layout.vue",
            _Ctor: {}
          },
          children: [
            {
              path: "",
              name: "Public-NT-NanoMark",
              meta: {
                title: "NT-NanoMark",
                icon: "dashboard",
                class: "material-icons",
                size: "16px",
                special: false
              }
            }
          ]
        },
        { path: "/privacy-policy", name: "privacy-policy", hidden: true },
        { path: "/404", redirect: { name: "Landing Page" }, hidden: true },
        { path: "*", redirect: "/404", hidden: true }
      ]
    };
  },
  created() {
    // console.log("permission_routers", JSON.stringify(this.permission_routers))
  },
  methods: {}
};
</script>
<style lang="scss">
// .scrollbar-wrapper {
//margin-top: 50px;
// }
.poweredBy {
  width: 80%;
  margin: 0 auto;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue